import {on} from './util';

export default class {
    static init = () => {
        aftermath();
    }
}

function aftermath() {
    // on() binds eagerly (querySelectorAll().forEach(), see util.ts) — 0 matches = 0 listeners,
    // which is the guard on every other page; no redundant document.querySelector check needed.
    on('change', 'input[name="aft_from"],input[name="aft_to"]', (element: HTMLInputElement) => {
        let from = element.name === 'aft_from' ? element.value : document.querySelector<HTMLInputElement>('input[name="aft_from"]')?.value;
        let to   = element.name === 'aft_to'   ? element.value : document.querySelector<HTMLInputElement>('input[name="aft_to"]')?.value;
        const params = new URLSearchParams(window.location.search); // trigger left untouched (D-12)
        if (from) { params.set('aft_from', from); } else { params.delete('aft_from'); }
        if (to)   { params.set('aft_to', to); }     else { params.delete('aft_to'); }
        location.href = '?' + params.toString();
    });
}
